<!-- <app-snow></app-snow> -->
<router-outlet></router-outlet>
<a
  id="gtmHablaEli"
  [href]="'https://wa.me/17327987210?text=%C2%A1Hola%20Eli!'"
  target="_blank"
  class="whatsapp-icon"
>
  <img [src]="urlImg + '/Eli.png'" alt="WhatsApp" />
</a>
